import React from "react";
import { FormGroup, Modal, ModalHeader, ModalFooter } from "reactstrap";
import SpinnerButton from "../../../components/Button";
import { BlurSpinner } from "../../../components/BlurSpinner";

function ConfirmPdfModal({ toggle, handleSubmitArea, isLoading }) {
  return (
    <BlurSpinner isLoading={isLoading}>
      <Modal centered backdrop="static" isOpen toggle={toggle}>
        <FormGroup>
          <ModalHeader toggle={toggle} className="text-center ">
            ¿Desea crear el PDF? Estará disponible en la pestaña de Archivos para descargar. Si ya existe una versión creada, se reemplazara por la nueva versión.
          </ModalHeader>
          <ModalFooter>
            <div className="mb-0 px-3 w-100 d-flex justify-content-between">
              <SpinnerButton className="btn btn-light" type="button" onClick={toggle}>
                Cancelar
              </SpinnerButton>
              <SpinnerButton className="btn btn-primary" type="button" onClick={handleSubmitArea}>
                Confirmar
              </SpinnerButton>
            </div>
          </ModalFooter>
        </FormGroup>
      </Modal>
    </BlurSpinner>
  );
}

export default ConfirmPdfModal;
